/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JTokenRouteImport } from './routes/j.$token'
import { Route as HelpRulesRouteImport } from './routes/help.rules'
import { Route as GamesCreateRouteImport } from './routes/games.create'
import { Route as GamesIdScoreboardRouteImport } from './routes/games.$id.scoreboard'
import { Route as GamesIdLobbyRouteImport } from './routes/games.$id.lobby'
import { Route as GamesIdFinishedRouteImport } from './routes/games.$id.finished'
import { Route as GamesIdRoundNRouteImport } from './routes/games.$id.round.$n'
import { Route as GamesIdScoresScoreIdAuditRouteImport } from './routes/games.$id.scores.$scoreId.audit'

const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const JTokenRoute = JTokenRouteImport.update({
  id: '/j/$token',
  path: '/j/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRulesRoute = HelpRulesRouteImport.update({
  id: '/help/rules',
  path: '/help/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesCreateRoute = GamesCreateRouteImport.update({
  id: '/games/create',
  path: '/games/create',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIdScoreboardRoute = GamesIdScoreboardRouteImport.update({
  id: '/games/$id/scoreboard',
  path: '/games/$id/scoreboard',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIdLobbyRoute = GamesIdLobbyRouteImport.update({
  id: '/games/$id/lobby',
  path: '/games/$id/lobby',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIdFinishedRoute = GamesIdFinishedRouteImport.update({
  id: '/games/$id/finished',
  path: '/games/$id/finished',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIdRoundNRoute = GamesIdRoundNRouteImport.update({
  id: '/games/$id/round/$n',
  path: '/games/$id/round/$n',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesIdScoresScoreIdAuditRoute =
  GamesIdScoresScoreIdAuditRouteImport.update({
    id: '/games/$id/scores/$scoreId/audit',
    path: '/games/$id/scores/$scoreId/audit',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/games/create': typeof GamesCreateRoute
  '/help/rules': typeof HelpRulesRoute
  '/j/$token': typeof JTokenRoute
  '/games/$id/finished': typeof GamesIdFinishedRoute
  '/games/$id/lobby': typeof GamesIdLobbyRoute
  '/games/$id/scoreboard': typeof GamesIdScoreboardRoute
  '/games/$id/round/$n': typeof GamesIdRoundNRoute
  '/games/$id/scores/$scoreId/audit': typeof GamesIdScoresScoreIdAuditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/games/create': typeof GamesCreateRoute
  '/help/rules': typeof HelpRulesRoute
  '/j/$token': typeof JTokenRoute
  '/games/$id/finished': typeof GamesIdFinishedRoute
  '/games/$id/lobby': typeof GamesIdLobbyRoute
  '/games/$id/scoreboard': typeof GamesIdScoreboardRoute
  '/games/$id/round/$n': typeof GamesIdRoundNRoute
  '/games/$id/scores/$scoreId/audit': typeof GamesIdScoresScoreIdAuditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/games/create': typeof GamesCreateRoute
  '/help/rules': typeof HelpRulesRoute
  '/j/$token': typeof JTokenRoute
  '/games/$id/finished': typeof GamesIdFinishedRoute
  '/games/$id/lobby': typeof GamesIdLobbyRoute
  '/games/$id/scoreboard': typeof GamesIdScoreboardRoute
  '/games/$id/round/$n': typeof GamesIdRoundNRoute
  '/games/$id/scores/$scoreId/audit': typeof GamesIdScoresScoreIdAuditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/profile'
    | '/games/create'
    | '/help/rules'
    | '/j/$token'
    | '/games/$id/finished'
    | '/games/$id/lobby'
    | '/games/$id/scoreboard'
    | '/games/$id/round/$n'
    | '/games/$id/scores/$scoreId/audit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/profile'
    | '/games/create'
    | '/help/rules'
    | '/j/$token'
    | '/games/$id/finished'
    | '/games/$id/lobby'
    | '/games/$id/scoreboard'
    | '/games/$id/round/$n'
    | '/games/$id/scores/$scoreId/audit'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/profile'
    | '/games/create'
    | '/help/rules'
    | '/j/$token'
    | '/games/$id/finished'
    | '/games/$id/lobby'
    | '/games/$id/scoreboard'
    | '/games/$id/round/$n'
    | '/games/$id/scores/$scoreId/audit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  ProfileRoute: typeof ProfileRoute
  GamesCreateRoute: typeof GamesCreateRoute
  HelpRulesRoute: typeof HelpRulesRoute
  JTokenRoute: typeof JTokenRoute
  GamesIdFinishedRoute: typeof GamesIdFinishedRoute
  GamesIdLobbyRoute: typeof GamesIdLobbyRoute
  GamesIdScoreboardRoute: typeof GamesIdScoreboardRoute
  GamesIdRoundNRoute: typeof GamesIdRoundNRoute
  GamesIdScoresScoreIdAuditRoute: typeof GamesIdScoresScoreIdAuditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/j/$token': {
      id: '/j/$token'
      path: '/j/$token'
      fullPath: '/j/$token'
      preLoaderRoute: typeof JTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/rules': {
      id: '/help/rules'
      path: '/help/rules'
      fullPath: '/help/rules'
      preLoaderRoute: typeof HelpRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/create': {
      id: '/games/create'
      path: '/games/create'
      fullPath: '/games/create'
      preLoaderRoute: typeof GamesCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$id/scoreboard': {
      id: '/games/$id/scoreboard'
      path: '/games/$id/scoreboard'
      fullPath: '/games/$id/scoreboard'
      preLoaderRoute: typeof GamesIdScoreboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$id/lobby': {
      id: '/games/$id/lobby'
      path: '/games/$id/lobby'
      fullPath: '/games/$id/lobby'
      preLoaderRoute: typeof GamesIdLobbyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$id/finished': {
      id: '/games/$id/finished'
      path: '/games/$id/finished'
      fullPath: '/games/$id/finished'
      preLoaderRoute: typeof GamesIdFinishedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$id/round/$n': {
      id: '/games/$id/round/$n'
      path: '/games/$id/round/$n'
      fullPath: '/games/$id/round/$n'
      preLoaderRoute: typeof GamesIdRoundNRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$id/scores/$scoreId/audit': {
      id: '/games/$id/scores/$scoreId/audit'
      path: '/games/$id/scores/$scoreId/audit'
      fullPath: '/games/$id/scores/$scoreId/audit'
      preLoaderRoute: typeof GamesIdScoresScoreIdAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  ProfileRoute: ProfileRoute,
  GamesCreateRoute: GamesCreateRoute,
  HelpRulesRoute: HelpRulesRoute,
  JTokenRoute: JTokenRoute,
  GamesIdFinishedRoute: GamesIdFinishedRoute,
  GamesIdLobbyRoute: GamesIdLobbyRoute,
  GamesIdScoreboardRoute: GamesIdScoreboardRoute,
  GamesIdRoundNRoute: GamesIdRoundNRoute,
  GamesIdScoresScoreIdAuditRoute: GamesIdScoresScoreIdAuditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
